import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

// --- Interfaces ---
import type {
	IColorScheme,
	IColorSchemes,
	ITheme,
	IThemes,
} from '@interfaces/appearance';
import type { AttachFileData } from '@interfaces/file';

@Injectable({
	providedIn: 'root',
})
export class AppearanceService {
	constructor(private readonly _http: HttpClient) {}

	// --- GET endpoints ---
	getThemes() {
		return this._http.get<IThemes>('preferences/Appearance/themes');
	}

	getTheme(id: ITheme['id']) {
		return this._http.get<ITheme>('preferences/Appearance/themes/' + id);
	}

	getThemeSearch(hostname: string) {
		const params = new HttpParams().set('hostname', hostname);

		return this._http.get<ITheme>('preferences/Appearance/themes/search', {
			params: params,
		});
	}

	getColorSchemes() {
		return this._http.get<IColorSchemes>(
			'preferences/Appearance/color-schemes'
		);
	}

	// --- POST endpoints ---

	postTheme(theme: ITheme) {
		const formData = new FormData();
		formData.append('name', theme.name);
		formData.append('colorSchemeId', String(theme.colorSchemeId));

		return this._http.post<ITheme>('preferences/Appearance/themes', formData);
	}

	changeTheme(id: number) {
		return this._http.post<ITheme>('preferences/Appearance/themes/' + id, {});
	}

	postColorScheme(colorScheme: IColorScheme) {
		return this._http.post<IColorScheme>(
			'preferences/Appearance/color-schemes',
			colorScheme
		);
	}

	postLogo(file: AttachFileData, themeId: ITheme['id']) {
		const formData = new FormData();
		formData.append('logo', file.file, file.filename);

		return this._http.post<ITheme>(
			'preferences/Appearance/themes/' + themeId + '/picture',
			formData
		);
	}

	// --- PUT endpoints ---
	putTheme(id: ITheme['id'], theme: ITheme) {
		return this._http.put<ITheme>('preferences/Appearance/themes/' + id, theme);
	}

	putColorScheme(id: IColorScheme['id'], colorScheme: IColorScheme) {
		return this._http.put<IColorScheme>(
			'preferences/Appearance/color-schemes/' + id,
			colorScheme
		);
	}

	deleteTheme(id: ITheme['id']) {
		return this._http.delete<ITheme>('preferences/Appearance/themes/' + id);
	}
}
